import {Montserrat, Montserrat_Alternates} from "next/font/google";
import React from "react";
import FontLoader from "@/base/components/util/FontLoader";

const MontserratAlternatesFont = Montserrat_Alternates({
	weight: ['300', '400', '500', '600', '700'],
	display: 'block',
	style: 'normal',
	subsets: ['cyrillic'],
	adjustFontFallback: false,
	fallback: ['sans-serif'],
});

const MontserratFont = Montserrat({
	weight: ['200', '300', '400', '500', '600'],
	display: 'block',
	style: 'normal',
	subsets: ['cyrillic'],
	adjustFontFallback: false,
	fallback: ['sans-serif'],
});

const MontserratFontLoader = ({children = null}: { children?: React.ReactNode }) => {
	return (
		<>
			<FontLoader variableName={'montserrat'} font={MontserratFont}/>
			<FontLoader variableName={'montserrat-alternates'} font={MontserratAlternatesFont}/>
		</>
	)
}
export default MontserratFontLoader;